import { render, staticRenderFns } from "./sponsor-ad.vue?vue&type=template&id=26111fcc&scoped=true"
import script from "./sponsor-ad.vue?vue&type=script&lang=js"
export * from "./sponsor-ad.vue?vue&type=script&lang=js"
import style0 from "./sponsor-ad.vue?vue&type=style&index=0&id=26111fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26111fcc",
  null
  
)

export default component.exports